


// import React, { useState, useEffect, useRef } from "react";
// import moment from "moment";
// import airports from "../../../Data/AirportList.json";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../../Common/Configurations/AuthContext";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   RiCalendarLine,
//   RiFlightTakeoffLine,
//   RiFlightLandLine,
//   RiSearchLine,
// } from "react-icons/ri";
// import "./ModifyFlightSearch1.css";

// const ModifyFlightSearch1 = ({ onSearch, initialSearchQuery }) => {
//   const navigate = useNavigate();
//   const { user, loading } = useAuth();
//   const { state } = useLocation();
  
//   // Original state management exactly as in ModifyFlightSearch
//   const [departureDate, setDepartureDate] = useState(new Date());
//   const [returnDate, setReturnDate] = useState(new Date());
//   const [departureResults, setDepartureResults] = useState([]);
//   const [arrivalResults, setArrivalResults] = useState([]);
//   const [locationFrom, setLocationFrom] = useState("HYD");
//   const [locationTo, setLocationTo] = useState("BOM");
//   const [displayFrom, setDisplayFrom] = useState("Hyderabad(HYD), India");
//   const [displayTo, setDisplayTo] = useState("Mumbai(BOM), India");
//   const [selectedDeparture, setSelectedDeparture] = useState(null);
//   const [selectedArrival, setSelectedArrival] = useState(null);
//   const [from, setFrom] = useState("Hyderabad, India");
//   const [to, setTo] = useState("Mumbai, India");
//   const [searchQuery, setSearchQuery] = useState({});
//   const [trips, setTrips] = useState([
//     {
//       from: "HYD, India",
//       to: "BOM, India",
//       locationFrom: "HYD",
//       locationTo: "BOM",
//       displayFrom: "Hyderabad(HYD)",
//       displayTo: "Mumbai(BOM)",
//       cityFrom: "Hyderabad",
//       cityTo: "Mumbai",
//       departureDate: new Date(),
//       departureResults: [],
//       arrivalResults: [],
//     },
//   ]);
//   const [adults, setAdults] = useState(1);
//   const [kids, setKids] = useState(0);
//   const [infants, setInfants] = useState(0);
//   const [cabinClass, setCabinClass] = useState("ECONOMY");
//   const [errors, setErrors] = useState({});
//   const [journeyType, setJourneyType] = useState("ONEWAY");
  
//   // Refs for new UI
//   const fromInputRef = useRef(null);
//   const toInputRef = useRef(null);
//   const fromDropdownRef = useRef(null);
//   const toDropdownRef = useRef(null);

//   // Custom date input component
//   const CustomDateInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
//     <div className="sf1-modify-input-group">
//       <input
//         type="text"
//         className="sf1-modify-form-control"
//         value={value}
//         onClick={onClick}
//         ref={ref}
//         readOnly
//         placeholder={placeholder || "Select date"}
//       />
//       <button className="sf1-modify-btn-secondary" type="button" onClick={onClick}>
//         <RiCalendarLine />
//       </button>
//     </div>
//   ));

//   // Original validate function
//   const validate = () => {
//     let temp = {};
//     temp.from = from === "" ? false : true;
//     temp.to = to === "" ? false : true;
//     setErrors(temp);
//     return Object.values(temp).every((x) => x === true);
//   };

//   // Original airport search functions
//   const handleDepartureAirportSearch = (e) => {
//     const value = e.target.value;
//     setDisplayFrom(value);
//     if (value.length > 0) {
//       const lowerValue = value.toLowerCase();
//       const filteredAirports = airports
//         .filter(
//           (airport) =>
//             airport.display === true &&
//             airport.airportCode.toLowerCase().includes(value.toLowerCase())
//         )
//         .slice(0, 10);
//       setDepartureResults(filteredAirports);
//       if (filteredAirports.length === 0) {
//         const filteredAirports1 = airports
//           .filter(
//             (airport) =>
//               airport.airportCode.toLowerCase().includes(lowerValue) ||
//               airport.cityName.toLowerCase().includes(lowerValue) ||
//               (airport.airportName.toLowerCase().includes(lowerValue) &&
//                 (!selectedArrival ||
//                   airport.airportCode !== selectedArrival.airportCode))
//           )
//           .slice(0, 10);
//         setDepartureResults(filteredAirports1);
//       }
//     } else {
//       setDepartureResults([]);
//     }
//   };

//   const handleDepartureAirportClick = (e) => {
//     setArrivalResults([]);
//     let filteredAirports = airports
//       .filter(function (p) {
//         return p.display === true;
//       })
//       .slice(0, 10);
//     setDepartureResults(filteredAirports);
//     fromInputRef.current.select();
//   };

//   const handleDepartureSelect = (data) => {
//     if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
//       alert("Departure and arrival airports cannot be the same.");
//       setSelectedArrival(null);
//       setDisplayTo("");
//       return;
//     } else {
//       var DF =
//         data.cityName + "(" + data.airportCode + "), " + data.countryName;
//       setDisplayFrom(DF);
//       setLocationFrom(data.airportCode);
//       setFrom(data.cityName);
//       setSelectedDeparture(data);
//       setDepartureResults([]);
//     }
//   };

//   const handleArrivalAirportSearch = (e) => {
//     const value = e.target.value;
//     setDisplayTo(value);
//     if (value.length > 0) {
//       const lowerValue = value.toLowerCase();
//       const filteredAirports = airports
//         .filter(
//           (airport) =>
//             airport.airportCode.toLowerCase().includes(lowerValue) ||
//             airport.cityName.toLowerCase().includes(lowerValue) ||
//             airport.airportName.toLowerCase().includes(lowerValue)
//         )
//         .slice(0, 10);
//       setArrivalResults(filteredAirports);
//       if (filteredAirports.length === 0) {
//         const filteredAirports1 = airports
//           .filter((airport) =>
//             airport.cityName.toLowerCase().includes(value.toLowerCase())
//           )
//           .slice(0, 10);
//         setArrivalResults(filteredAirports1);
//       }
//     } else {
//       setArrivalResults([]);
//     }
//   };

//   const handleArrivalSelect = (data) => {
//     if (
//       selectedDeparture &&
//       selectedDeparture.airportCode === data.airportCode
//     ) {
//       alert("Arrival and departure airports cannot be the same.");
//       setSelectedDeparture(null);
//       setDisplayFrom("");
//       return;
//     } else {
//       var DF =
//         data.cityName + "(" + data.airportCode + "), " + data.countryName;
//       setDisplayTo(DF);
//       setLocationTo(data.airportCode);
//       setTo(data.cityName);
//       setSelectedArrival(data);
//       setArrivalResults([]);
//     }
//   };

//   const handleArrivalAirportClick = (e) => {
//     setDepartureResults([]);
//     let filteredAirports = airports
//       .filter(function (p) {
//         return p.display === true;
//       })
//       .slice(0, 10);
//     setArrivalResults(filteredAirports);
//     toInputRef.current.select();
//   };

//   // Original passenger handlers
//   const handleClassType = (e) => {
//     setCabinClass(e.target.value);
//   };

//   const handleIncreaseAdults = (e) => {
//     e.stopPropagation();
//     setAdults(parseFloat(adults + 1));
//   };

//   const handleDecreaseAdults = (e) => {
//     e.stopPropagation();
//     if (adults !== 1) {
//       setAdults(parseFloat(adults - 1));
//     }
//   };

//   const handleIncreaseKids = (e) => {
//     e.stopPropagation();
//     setKids(parseFloat(kids + 1));
//   };

//   const handleDecreaseKids = (e) => {
//     e.stopPropagation();
//     if (kids !== 0) {
//       setKids(parseFloat(kids - 1));
//     }
//   };

//   const handleIncreaseInfants = (e) => {
//     e.stopPropagation();
//     setInfants(parseFloat(infants + 1));
//   };

//   const handleDecreaseInfants = (e) => {
//     e.stopPropagation();
//     if (infants !== 0) {
//       setInfants(parseFloat(infants - 1));
//     }
//   };

//   const handleDepartureDateChange = (date) => {
//     const selectedDate = date;
//     setDepartureDate(selectedDate);
//     if (returnDate && selectedDate && returnDate < selectedDate) {
//       setReturnDate(selectedDate);
//     }
//   };

//   const handleReturnDateChange = (date) => {
//     setReturnDate(date);
//   };

//   const handleJourneyType = (e) => {
//     e.preventDefault();
//     setJourneyType(e.target.value);
//   };

//   // Fixed GetFlightDestinations function
//   function GetFlightDestinations() {
//     const fvalues = [];
//     for (var i = 0; i < trips.length; i++) {
//       fvalues.push({
//         from: locationFrom,
//         to: locationTo,
//         departureDate: moment(departureDate).format("YYYY-MM-DD"),
//         returnDate: journeyType === "RETURN" ? moment(returnDate).format("YYYY-MM-DD") : null,
//       });
//     }
//     return fvalues;
//   }

//   // Original handleSearch
//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (validate()) {
//       const searchQuery = {
//         journeyType: journeyType,
//         isDomestic: "DOMESTIC",
//         adults: adults,
//         kids: kids,
//         infants: infants,
//         cabinClass: cabinClass,
//         companyId: user?.isSupplierAPI === true ? user.cid : user.parentCompanyId,
//         preferred: "REGULAR",
//         isDirectFlight: false,
//         isConnectingFlight: false,
//         flightTravelerPoints: GetFlightDestinations(),
//       };
//       console.log("Modify Search Query:", searchQuery);
//       if (onSearch) {
//         onSearch(searchQuery);
//       }
//       navigate(
//         "/template/flights/" + adults + "/" + kids + "/" + infants + "/DOMESTIC",
//         {
//           replace: true,
//           state: { searchQuery },
//         }
//       );
//     }
//   };

//   // Original useEffect to initialize form with search query data
//   useEffect(() => {
//     const queryToUse = state?.searchQuery || initialSearchQuery;
    
//     if (queryToUse) {
//       console.log("Initializing with query:", queryToUse);
//       setSearchQuery(queryToUse);
//       setJourneyType(queryToUse.journeyType);
//       setCabinClass(queryToUse.cabinClass);
//       setAdults(queryToUse.adults || 1);
//       setKids(queryToUse.kids || 0);
//       setInfants(queryToUse.infants || 0);
      
//       const dAirports = airports.find(
//         (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.from
//       );
//       if (dAirports) {
//         var DF =
//           dAirports?.cityName +
//           "(" +
//           dAirports?.airportCode +
//           "), " +
//           dAirports?.countryName;
//         setLocationFrom(dAirports?.airportCode);
//         setDisplayFrom(DF);
//         setFrom(dAirports?.cityName);
//         setSelectedDeparture(dAirports);
//       }
      
//       const rAirports = airports.find(
//         (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.to
//       );
//       if (rAirports) {
//         var DR =
//           rAirports?.cityName +
//           "(" +
//           rAirports?.airportCode +
//           "), " +
//           rAirports?.countryName;
//         setLocationTo(rAirports.airportCode);
//         setDisplayTo(DR);
//         setTo(rAirports.cityName);
//         setSelectedArrival(rAirports);
//       }
      
//       if (queryToUse?.flightTravelerPoints?.[0]?.departureDate) {
//         setDepartureDate(
//           new Date(queryToUse?.flightTravelerPoints?.[0]?.departureDate)
//         );
//       }
      
//       if (queryToUse?.flightTravelerPoints?.[0]?.returnDate) {
//         setReturnDate(
//           new Date(queryToUse?.flightTravelerPoints?.[0]?.returnDate)
//         );
//       }
//     }
//   }, [state, initialSearchQuery]);

//   // Get passenger display text for new UI
//   const getPassengerDisplay = () => {
//     return `${adults} Adult${adults !== 1 ? 's' : ''}${
//       kids > 0 ? `, ${kids} Kid${kids !== 1 ? 's' : ''}` : ''
//     }${
//       infants > 0 ? `, ${infants} Infant${infants !== 1 ? 's' : ''}` : ''
//     } & ${cabinClass}`;
//   };

//   // Close dropdowns when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (fromDropdownRef.current && !fromDropdownRef.current.contains(event.target) && 
//           fromInputRef.current && !fromInputRef.current.contains(event.target)) {
//         setDepartureResults([]);
//       }
      
//       if (toDropdownRef.current && !toDropdownRef.current.contains(event.target) && 
//           toInputRef.current && !toInputRef.current.contains(event.target)) {
//         setArrivalResults([]);
//       }
//     };
    
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   if (loading) return <p>Loading...</p>;
//   if (!user) return null;

//   return (
//     <div className="sf1-modify-search-card">
//       <div className="sf1-modify-search-row">
//         {/* Journey Type Selector */}
//         <div className="sf1-modify-field">
//           <label>Type</label>
//           <select 
//             className="sf1-modify-select" 
//             value={journeyType} 
//             onChange={handleJourneyType}
//           >
//             <option value="ONEWAY">ONEWAY</option>
//             <option value="RETURN">ROUNDTRIP</option>
//           </select>
//         </div>

//         {/* From Field */}
//         <div className="sf1-modify-field">
//           <label>From</label>
//           <div className="sf1-modify-input-with-icon">
//             <input
//               ref={fromInputRef}
//               type="text"
//               value={displayFrom}
//               onChange={handleDepartureAirportSearch}
//               onFocus={handleDepartureAirportClick}
//               onClick={handleDepartureAirportClick}
//               placeholder="Search for an airport"
//               autoComplete="off"
//             />
//           </div>
//           {departureResults.length > 0 && (
//             <ul className="sf1-modify-airport-dropdown" ref={fromDropdownRef}>
//               {departureResults.map((airport) => (
//                 <li
//                   key={airport.airportCode}
//                   className="sf1-modify-airport-item"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     e.stopPropagation();
//                     handleDepartureSelect(airport);
//                   }}
//                 >
//                   <div className="sf1-modify-airport-name">
//                     {airport.cityName} ({airport.airportCode})
//                   </div>
//                   <div className="sf1-modify-airport-details">
//                     {airport.airportName}, {airport.countryName}
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>

//         {/* To Field */}
//         <div className="sf1-modify-field">
//           <label>To</label>
//           <div className="sf1-modify-input-with-icon">
//             <input
//               ref={toInputRef}
//               type="text"
//               value={displayTo}
//               onChange={handleArrivalAirportSearch}
//               onFocus={handleArrivalAirportClick}
//               onClick={handleArrivalAirportClick}
//               placeholder="Search for an airport"
//               autoComplete="off"
//             />
//           </div>
//           {arrivalResults.length > 0 && (
//             <ul className="sf1-modify-airport-dropdown" ref={toDropdownRef}>
//               {arrivalResults.map((airport) => (
//                 <li
//                   key={airport.airportCode}
//                   className="sf1-modify-airport-item"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     e.stopPropagation();
//                     handleArrivalSelect(airport);
//                   }}
//                 >
//                   <div className="sf1-modify-airport-name">
//                     {airport.cityName} ({airport.airportCode})
//                   </div>
//                   <div className="sf1-modify-airport-details">
//                     {airport.airportName}, {airport.countryName}
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>

//         {/* Departure Date */}
//         <div className="sf1-modify-field">
//           <label>Depart</label>
//           <DatePicker
//             selected={departureDate}
//             onChange={handleDepartureDateChange}
//             customInput={<CustomDateInput placeholder="Departure Date" />}
//             dateFormat="dd MMM yyyy"
//             showYearDropdown
//             showMonthDropdown
//             dropdownMode="select"
//             minDate={new Date()}
//             yearDropdownItemNumber={50}
//             scrollableYearDropdown
//           />
//         </div>

//         {/* Return Date (for roundtrip) */}
//         {journeyType === "RETURN" && (
//           <div className="sf1-modify-field">
//             <label>Return</label>
//             <DatePicker
//               selected={returnDate}
//               onChange={handleReturnDateChange}
//               customInput={<CustomDateInput placeholder="Return Date" />}
//               dateFormat="dd MMM yyyy"
//               showYearDropdown
//               showMonthDropdown
//               dropdownMode="select"
//               minDate={departureDate}
//               yearDropdownItemNumber={50}
//               scrollableYearDropdown
//             />
//           </div>
//         )}

//         {/* Travellers & Class Dropdown */}
//         <div className="sf1-modify-field">
//           <label>Travellers</label>
//           <div className="sf1-modify-passenger-dropdown-container">
//             <div className="sf1-modify-passenger-select">
//               {getPassengerDisplay()}
//             </div>
            
//             <div className="sf1-modify-passenger-controls">
//               <div className="sf1-modify-passenger-row">
//                 <span>Adults</span>
//                 <div className="sf1-modify-input-step">
//                   <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseAdults}>-</button>
//                   <span className="sf1-modify-step-value">{adults}</span>
//                   <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseAdults}>+</button>
//                 </div>
//               </div>
//               <div className="sf1-modify-passenger-row">
//                 <span>Kids</span>
//                 <div className="sf1-modify-input-step">
//                   <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseKids}>-</button>
//                   <span className="sf1-modify-step-value">{kids}</span>
//                   <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseKids}>+</button>
//                 </div>
//               </div>
//               <div className="sf1-modify-passenger-row">
//                 <span>Infants</span>
//                 <div className="sf1-modify-input-step">
//                   <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseInfants}>-</button>
//                   <span className="sf1-modify-step-value">{infants}</span>
//                   <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseInfants}>+</button>
//                 </div>
//               </div>
//               <div className="sf1-modify-cabin-options">
//                 <div className="sf1-modify-cabin-row">
//                   <label className="sf1-modify-cabin-check">
//                     <input
//                       type="radio"
//                       name="cabinClass"
//                       value="ECONOMY"
//                       checked={cabinClass === "ECONOMY"}
//                       onChange={handleClassType}
//                     />
//                     REGULAR
//                   </label>
//                   <label className="sf1-modify-cabin-check">
//                     <input
//                       type="radio"
//                       name="cabinClass"
//                       value="BUSINESS"
//                       checked={cabinClass === "BUSINESS"}
//                       onChange={handleClassType}
//                     />
//                     BUSINESS
//                   </label>
//                 </div>
//                 <div className="sf1-modify-cabin-row">
//                   <label className="sf1-modify-cabin-check">
//                     <input
//                       type="radio"
//                       name="cabinClass"
//                       value="FIRST"
//                       checked={cabinClass === "FIRST"}
//                       onChange={handleClassType}
//                     />
//                     FIRST
//                   </label>
//                   <label className="sf1-modify-cabin-check">
//                     <input
//                       type="radio"
//                       name="cabinClass"
//                       value="PREMIUM_ECONOMY"
//                       checked={cabinClass === "PREMIUM_ECONOMY"}
//                       onChange={handleClassType}
//                     />
//                     PREMIUM ECONOMY
//                   </label>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Search Button */}
//         <button type="button" className="sf1-modify-search-btn" onClick={handleSearch}>
//           <RiSearchLine className="sf1-modify-search-icon" />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ModifyFlightSearch1;

import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import airports from "../../../Data/AirportList.json";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  RiCalendarLine,
  RiFlightTakeoffLine,
  RiFlightLandLine,
  RiSearchLine,
} from "react-icons/ri";
import "./ModifyFlightSearch1.css";

const ModifyFlightSearch1 = ({ onSearch, initialSearchQuery }) => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { state } = useLocation();
  
  // Original state management exactly as in ModifyFlightSearch
  const [departureDate, setDepartureDate] = useState(new Date());
  const [returnDate, setReturnDate] = useState(new Date());
  const [departureResults, setDepartureResults] = useState([]);
  const [arrivalResults, setArrivalResults] = useState([]);
  const [locationFrom, setLocationFrom] = useState("HYD");
  const [locationTo, setLocationTo] = useState("BOM");
  const [displayFrom, setDisplayFrom] = useState("Hyderabad(HYD), India");
  const [displayTo, setDisplayTo] = useState("Mumbai(BOM), India");
  const [selectedDeparture, setSelectedDeparture] = useState(null);
  const [selectedArrival, setSelectedArrival] = useState(null);
  const [from, setFrom] = useState("Hyderabad, India");
  const [to, setTo] = useState("Mumbai, India");
  const [searchQuery, setSearchQuery] = useState({});
  const [trips, setTrips] = useState([
    {
      from: "HYD, India",
      to: "BOM, India",
      locationFrom: "HYD",
      locationTo: "BOM",
      displayFrom: "Hyderabad(HYD)",
      displayTo: "Mumbai(BOM)",
      cityFrom: "Hyderabad",
      cityTo: "Mumbai",
      departureDate: new Date(),
      departureResults: [],
      arrivalResults: [],
    },
  ]);
  const [adults, setAdults] = useState(1);
  const [kids, setKids] = useState(0);
  const [infants, setInfants] = useState(0);
  const [cabinClass, setCabinClass] = useState("ECONOMY");
  const [errors, setErrors] = useState({});
  const [journeyType, setJourneyType] = useState("ONEWAY");
  
  // Refs for new UI
  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);
  const fromDropdownRef = useRef(null);
  const toDropdownRef = useRef(null);

  // Custom date input component
  const CustomDateInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
    <div className="sf1-modify-input-group">
      <input
        type="text"
        className="sf1-modify-form-control"
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        placeholder={placeholder || "Select date"}
      />
      <button className="sf1-modify-btn-secondary" type="button" onClick={onClick}>
        <RiCalendarLine />
      </button>
    </div>
  ));

  // Original validate function
  const validate = () => {
    let temp = {};
    temp.from = from === "" ? false : true;
    temp.to = to === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  // Original airport search functions
  const handleDepartureAirportSearch = (e) => {
    const value = e.target.value;
    setDisplayFrom(value);
    if (value.length > 0) {
      const lowerValue = value.toLowerCase();
      const filteredAirports = airports
        .filter(
          (airport) =>
            airport.display === true &&
            airport.airportCode.toLowerCase().includes(value.toLowerCase())
        )
        .slice(0, 10);
      setDepartureResults(filteredAirports);
      if (filteredAirports.length === 0) {
        const filteredAirports1 = airports
          .filter(
            (airport) =>
              airport.airportCode.toLowerCase().includes(lowerValue) ||
              airport.cityName.toLowerCase().includes(lowerValue) ||
              (airport.airportName.toLowerCase().includes(lowerValue) &&
                (!selectedArrival ||
                  airport.airportCode !== selectedArrival.airportCode))
          )
          .slice(0, 10);
        setDepartureResults(filteredAirports1);
      }
    } else {
      setDepartureResults([]);
    }
  };

  const handleDepartureAirportClick = (e) => {
    setArrivalResults([]);
    let filteredAirports = airports
      .filter(function (p) {
        return p.display === true;
      })
      .slice(0, 10);
    setDepartureResults(filteredAirports);
    fromInputRef.current.select();
  };

  const handleDepartureSelect = (data) => {
    if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
      alert("Departure and arrival airports cannot be the same.");
      setSelectedArrival(null);
      setDisplayTo("");
      return;
    } else {
      var DF =
        data.cityName + "(" + data.airportCode + "), " + data.countryName;
      setDisplayFrom(DF);
      setLocationFrom(data.airportCode);
      setFrom(data.cityName);
      setSelectedDeparture(data);
      setDepartureResults([]);
    }
  };

  const handleArrivalAirportSearch = (e) => {
    const value = e.target.value;
    setDisplayTo(value);
    if (value.length > 0) {
      const lowerValue = value.toLowerCase();
      const filteredAirports = airports
        .filter(
          (airport) =>
            airport.airportCode.toLowerCase().includes(lowerValue) ||
            airport.cityName.toLowerCase().includes(lowerValue) ||
            airport.airportName.toLowerCase().includes(lowerValue)
        )
        .slice(0, 10);
      setArrivalResults(filteredAirports);
      if (filteredAirports.length === 0) {
        const filteredAirports1 = airports
          .filter((airport) =>
            airport.cityName.toLowerCase().includes(value.toLowerCase())
          )
          .slice(0, 10);
        setArrivalResults(filteredAirports1);
      }
    } else {
      setArrivalResults([]);
    }
  };

  const handleArrivalSelect = (data) => {
    if (
      selectedDeparture &&
      selectedDeparture.airportCode === data.airportCode
    ) {
      alert("Arrival and departure airports cannot be the same.");
      setSelectedDeparture(null);
      setDisplayFrom("");
      return;
    } else {
      var DF =
        data.cityName + "(" + data.airportCode + "), " + data.countryName;
      setDisplayTo(DF);
      setLocationTo(data.airportCode);
      setTo(data.cityName);
      setSelectedArrival(data);
      setArrivalResults([]);
    }
  };

  const handleArrivalAirportClick = (e) => {
    setDepartureResults([]);
    let filteredAirports = airports
      .filter(function (p) {
        return p.display === true;
      })
      .slice(0, 10);
    setArrivalResults(filteredAirports);
    toInputRef.current.select();
  };

  // Original passenger handlers
  const handleClassType = (e) => {
    setCabinClass(e.target.value);
  };

  const handleIncreaseAdults = (e) => {
    e.stopPropagation();
    setAdults(parseFloat(adults + 1));
  };

  const handleDecreaseAdults = (e) => {
    e.stopPropagation();
    if (adults !== 1) {
      setAdults(parseFloat(adults - 1));
    }
  };

  const handleIncreaseKids = (e) => {
    e.stopPropagation();
    setKids(parseFloat(kids + 1));
  };

  const handleDecreaseKids = (e) => {
    e.stopPropagation();
    if (kids !== 0) {
      setKids(parseFloat(kids - 1));
    }
  };

  const handleIncreaseInfants = (e) => {
    e.stopPropagation();
    setInfants(parseFloat(infants + 1));
  };

  const handleDecreaseInfants = (e) => {
    e.stopPropagation();
    if (infants !== 0) {
      setInfants(parseFloat(infants - 1));
    }
  };

  const handleDepartureDateChange = (date) => {
    const selectedDate = date;
    setDepartureDate(selectedDate);
    if (returnDate && selectedDate && returnDate < selectedDate) {
      setReturnDate(selectedDate);
    }
  };

  const handleReturnDateChange = (date) => {
    setReturnDate(date);
  };

  const handleJourneyType = (e) => {
    e.preventDefault();
    setJourneyType(e.target.value);
  };

  // Fixed GetFlightDestinations function
  function GetFlightDestinations() {
    const fvalues = [];
    for (var i = 0; i < trips.length; i++) {
      fvalues.push({
        from: locationFrom,
        to: locationTo,
        departureDate: moment(departureDate).format("YYYY-MM-DD"),
        returnDate: journeyType === "RETURN" ? moment(returnDate).format("YYYY-MM-DD") : null,
      });
    }
    return fvalues;
  }

  // Updated handleSearch - REMOVED navigation, only calls onSearch
  const handleSearch = (e) => {
    e.preventDefault();
    if (validate()) {
      const searchQuery = {
        journeyType: journeyType,
        isDomestic: "DOMESTIC",
        adults: adults,
        kids: kids,
        infants: infants,
        cabinClass: cabinClass,
        companyId: user?.isSupplierAPI === true ? user.cid : user.parentCompanyId,
        preferred: "REGULAR",
        isDirectFlight: false,
        isConnectingFlight: false,
        flightTravelerPoints: GetFlightDestinations(),
      };
      console.log("Modify Search Query:", searchQuery);
      
      // Call the onSearch prop from parent component
      if (onSearch) {
        onSearch(searchQuery);
      }
    }
  };

  // Original useEffect to initialize form with search query data
  useEffect(() => {
    const queryToUse = state?.searchQuery || initialSearchQuery;
    
    if (queryToUse) {
      console.log("Initializing with query:", queryToUse);
      setSearchQuery(queryToUse);
      setJourneyType(queryToUse.journeyType);
      setCabinClass(queryToUse.cabinClass);
      setAdults(queryToUse.adults || 1);
      setKids(queryToUse.kids || 0);
      setInfants(queryToUse.infants || 0);
      
      const dAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.from
      );
      if (dAirports) {
        var DF =
          dAirports?.cityName +
          "(" +
          dAirports?.airportCode +
          "), " +
          dAirports?.countryName;
        setLocationFrom(dAirports?.airportCode);
        setDisplayFrom(DF);
        setFrom(dAirports?.cityName);
        setSelectedDeparture(dAirports);
      }
      
      const rAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.to
      );
      if (rAirports) {
        var DR =
          rAirports?.cityName +
          "(" +
          rAirports?.airportCode +
          "), " +
          rAirports?.countryName;
        setLocationTo(rAirports.airportCode);
        setDisplayTo(DR);
        setTo(rAirports.cityName);
        setSelectedArrival(rAirports);
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.departureDate) {
        setDepartureDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.departureDate)
        );
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.returnDate) {
        setReturnDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.returnDate)
        );
      }
    }
  }, [state, initialSearchQuery]);

  // NEW useEffect to update when initialSearchQuery changes from parent
  useEffect(() => {
    // This effect will run when initialSearchQuery changes
    const queryToUse = initialSearchQuery;
    
    if (queryToUse) {
      console.log("Updating form with new query:", queryToUse);
      setJourneyType(queryToUse.journeyType);
      setCabinClass(queryToUse.cabinClass);
      setAdults(queryToUse.adults || 1);
      setKids(queryToUse.kids || 0);
      setInfants(queryToUse.infants || 0);
      
      const dAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.from
      );
      if (dAirports) {
        var DF =
          dAirports?.cityName +
          "(" +
          dAirports?.airportCode +
          "), " +
          dAirports?.countryName;
        setLocationFrom(dAirports?.airportCode);
        setDisplayFrom(DF);
        setFrom(dAirports?.cityName);
        setSelectedDeparture(dAirports);
      }
      
      const rAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.to
      );
      if (rAirports) {
        var DR =
          rAirports?.cityName +
          "(" +
          rAirports?.airportCode +
          "), " +
          rAirports?.countryName;
        setLocationTo(rAirports.airportCode);
        setDisplayTo(DR);
        setTo(rAirports.cityName);
        setSelectedArrival(rAirports);
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.departureDate) {
        setDepartureDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.departureDate)
        );
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.returnDate) {
        setReturnDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.returnDate)
        );
      }
    }
  }, [initialSearchQuery]); // This dependency is key

  // Get passenger display text for new UI
  const getPassengerDisplay = () => {
    return `${adults} Adult${adults !== 1 ? 's' : ''}${
      kids > 0 ? `, ${kids} Kid${kids !== 1 ? 's' : ''}` : ''
    }${
      infants > 0 ? `, ${infants} Infant${infants !== 1 ? 's' : ''}` : ''
    } & ${cabinClass}`;
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fromDropdownRef.current && !fromDropdownRef.current.contains(event.target) && 
          fromInputRef.current && !fromInputRef.current.contains(event.target)) {
        setDepartureResults([]);
      }
      
      if (toDropdownRef.current && !toDropdownRef.current.contains(event.target) && 
          toInputRef.current && !toInputRef.current.contains(event.target)) {
        setArrivalResults([]);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!user) return null;

  return (
    <div className="sf1-modify-search-card">
      <div className="sf1-modify-search-row">
        {/* Journey Type Selector */}
        <div className="sf1-modify-field">
          <label>Type</label>
          <select 
            className="sf1-modify-select" 
            value={journeyType} 
            onChange={handleJourneyType}
          >
            <option value="ONEWAY">ONEWAY</option>
            <option value="RETURN">ROUNDTRIP</option>
          </select>
        </div>

        {/* From Field */}
        <div className="sf1-modify-field">
          <label>From</label>
          <div className="sf1-modify-input-with-icon">
            <input
              ref={fromInputRef}
              type="text"
              value={displayFrom}
              onChange={handleDepartureAirportSearch}
              onFocus={handleDepartureAirportClick}
              onClick={handleDepartureAirportClick}
              placeholder="Search for an airport"
              autoComplete="off"
            />
          </div>
          {departureResults.length > 0 && (
            <ul className="sf1-modify-airport-dropdown" ref={fromDropdownRef}>
              {departureResults.map((airport) => (
                <li
                  key={airport.airportCode}
                  className="sf1-modify-airport-item"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleDepartureSelect(airport);
                  }}
                >
                  <div className="sf1-modify-airport-name">
                    {airport.cityName} ({airport.airportCode})
                  </div>
                  <div className="sf1-modify-airport-details">
                    {airport.airportName}, {airport.countryName}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* To Field */}
        <div className="sf1-modify-field">
          <label>To</label>
          <div className="sf1-modify-input-with-icon">
            <input
              ref={toInputRef}
              type="text"
              value={displayTo}
              onChange={handleArrivalAirportSearch}
              onFocus={handleArrivalAirportClick}
              onClick={handleArrivalAirportClick}
              placeholder="Search for an airport"
              autoComplete="off"
            />
          </div>
          {arrivalResults.length > 0 && (
            <ul className="sf1-modify-airport-dropdown" ref={toDropdownRef}>
              {arrivalResults.map((airport) => (
                <li
                  key={airport.airportCode}
                  className="sf1-modify-airport-item"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleArrivalSelect(airport);
                  }}
                >
                  <div className="sf1-modify-airport-name">
                    {airport.cityName} ({airport.airportCode})
                  </div>
                  <div className="sf1-modify-airport-details">
                    {airport.airportName}, {airport.countryName}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Departure Date */}
        <div className="sf1-modify-field">
          <label>Depart</label>
          <DatePicker
            selected={departureDate}
            onChange={handleDepartureDateChange}
            customInput={<CustomDateInput placeholder="Departure Date" />}
            dateFormat="dd MMM yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            minDate={new Date()}
            yearDropdownItemNumber={50}
            scrollableYearDropdown
          />
        </div>

        {/* Return Date (for roundtrip) */}
        {journeyType === "RETURN" && (
          <div className="sf1-modify-field">
            <label>Return</label>
            <DatePicker
              selected={returnDate}
              onChange={handleReturnDateChange}
              customInput={<CustomDateInput placeholder="Return Date" />}
              dateFormat="dd MMM yyyy"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              minDate={departureDate}
              yearDropdownItemNumber={50}
              scrollableYearDropdown
            />
          </div>
        )}

        {/* Travellers & Class Dropdown */}
        <div className="sf1-modify-field">
          <label>Travellers</label>
          <div className="sf1-modify-passenger-dropdown-container">
            <div className="sf1-modify-passenger-select">
              {getPassengerDisplay()}
            </div>
            
            <div className="sf1-modify-passenger-controls">
              <div className="sf1-modify-passenger-row">
                <span>Adults</span>
                <div className="sf1-modify-input-step">
                  <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseAdults}>-</button>
                  <span className="sf1-modify-step-value">{adults}</span>
                  <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseAdults}>+</button>
                </div>
              </div>
              <div className="sf1-modify-passenger-row">
                <span>Kids</span>
                <div className="sf1-modify-input-step">
                  <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseKids}>-</button>
                  <span className="sf1-modify-step-value">{kids}</span>
                  <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseKids}>+</button>
                </div>
              </div>
              <div className="sf1-modify-passenger-row">
                <span>Infants</span>
                <div className="sf1-modify-input-step">
                  <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseInfants}>-</button>
                  <span className="sf1-modify-step-value">{infants}</span>
                  <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseInfants}>+</button>
                </div>
              </div>
              <div className="sf1-modify-cabin-options">
                <div className="sf1-modify-cabin-row">
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="ECONOMY"
                      checked={cabinClass === "ECONOMY"}
                      onChange={handleClassType}
                    />
                    ECONOMY
                  </label>
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="BUSINESS"
                      checked={cabinClass === "BUSINESS"}
                      onChange={handleClassType}
                    />
                    BUSINESS
                  </label>
                </div>
                <div className="sf1-modify-cabin-row">
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="FIRST"
                      checked={cabinClass === "FIRST"}
                      onChange={handleClassType}
                    />
                    FIRST
                  </label>
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="PREMIUM_ECONOMY"
                      checked={cabinClass === "PREMIUM_ECONOMY"}
                      onChange={handleClassType}
                    />
                    PREMIUM ECONOMY
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search Button */}
        <button type="button" className="sf1-modify-search-btn" onClick={handleSearch}>
          <RiSearchLine className="sf1-modify-search-icon" />
        </button>
      </div>
    </div>
  );
};

export default ModifyFlightSearch1;